/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiBillingWorklistGetCndnWorklistPost } from '../fn/billing-worklist/api-billing-worklist-get-cndn-worklist-post';
import { ApiBillingWorklistGetCndnWorklistPost$Params } from '../fn/billing-worklist/api-billing-worklist-get-cndn-worklist-post';
import { apiBillingWorklistGetInvoiceWorklistPost } from '../fn/billing-worklist/api-billing-worklist-get-invoice-worklist-post';
import { ApiBillingWorklistGetInvoiceWorklistPost$Params } from '../fn/billing-worklist/api-billing-worklist-get-invoice-worklist-post';
import { apiBillingWorklistGetReceiptWorklistPost } from '../fn/billing-worklist/api-billing-worklist-get-receipt-worklist-post';
import { ApiBillingWorklistGetReceiptWorklistPost$Params } from '../fn/billing-worklist/api-billing-worklist-get-receipt-worklist-post';
import { CndnWorklist } from '../models/cndn-worklist';
import { InvoiceWorklist } from '../models/invoice-worklist';
import { ReceiptWorklist } from '../models/receipt-worklist';

@Injectable({ providedIn: 'root' })
export class BillingWorklistService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiBillingWorklistGetInvoiceWorklistPost()` */
  static readonly ApiBillingWorklistGetInvoiceWorklistPostPath = '/api/BillingWorklist/GetInvoiceWorklist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBillingWorklistGetInvoiceWorklistPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiBillingWorklistGetInvoiceWorklistPost$Response(params?: ApiBillingWorklistGetInvoiceWorklistPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InvoiceWorklist>>> {
    return apiBillingWorklistGetInvoiceWorklistPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBillingWorklistGetInvoiceWorklistPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiBillingWorklistGetInvoiceWorklistPost(params?: ApiBillingWorklistGetInvoiceWorklistPost$Params, context?: HttpContext): Observable<Array<InvoiceWorklist>> {
    return this.apiBillingWorklistGetInvoiceWorklistPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<InvoiceWorklist>>): Array<InvoiceWorklist> => r.body)
    );
  }

  /** Path part for operation `apiBillingWorklistGetCndnWorklistPost()` */
  static readonly ApiBillingWorklistGetCndnWorklistPostPath = '/api/BillingWorklist/GetCndnWorklist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBillingWorklistGetCndnWorklistPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiBillingWorklistGetCndnWorklistPost$Response(params?: ApiBillingWorklistGetCndnWorklistPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CndnWorklist>>> {
    return apiBillingWorklistGetCndnWorklistPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBillingWorklistGetCndnWorklistPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiBillingWorklistGetCndnWorklistPost(params?: ApiBillingWorklistGetCndnWorklistPost$Params, context?: HttpContext): Observable<Array<CndnWorklist>> {
    return this.apiBillingWorklistGetCndnWorklistPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CndnWorklist>>): Array<CndnWorklist> => r.body)
    );
  }

  /** Path part for operation `apiBillingWorklistGetReceiptWorklistPost()` */
  static readonly ApiBillingWorklistGetReceiptWorklistPostPath = '/api/BillingWorklist/GetReceiptWorklist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBillingWorklistGetReceiptWorklistPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiBillingWorklistGetReceiptWorklistPost$Response(params?: ApiBillingWorklistGetReceiptWorklistPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReceiptWorklist>>> {
    return apiBillingWorklistGetReceiptWorklistPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBillingWorklistGetReceiptWorklistPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiBillingWorklistGetReceiptWorklistPost(params?: ApiBillingWorklistGetReceiptWorklistPost$Params, context?: HttpContext): Observable<Array<ReceiptWorklist>> {
    return this.apiBillingWorklistGetReceiptWorklistPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReceiptWorklist>>): Array<ReceiptWorklist> => r.body)
    );
  }

}
